import script from "./IPT.vue?vue&type=script&setup=true&lang=js"
export * from "./IPT.vue?vue&type=script&setup=true&lang=js"

import "./IPT.vue?vue&type=style&index=0&id=3b147e6f&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b147e6f"]])

export default __exports__